module.exports = __webpack_public_path__ + "static/media/bankIconPms.225ce647.png";